export default __webpack_public_path__ + "static/media/151-shower.aec09922.png";